import { CalendarItemType } from '@akin-home/amplify';
import { v4 as uuid } from 'uuid';

import { Alert } from '../types';

export const createAlertModel = (input: Partial<Alert>): Alert => ({
  id: uuid(),
  type: CalendarItemType.Alert,
  habitatID: '',
  recurrenceExcludeDates: {},
  title: '',
  start: new Date(),

  updatedAt: new Date().toISOString(),
  createdAt: new Date().toISOString(),

  checklist: [],
  ...input,
});
